import Vue from "./../init";

export const NotificationResource = Vue.resource("notification");
